import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SettingsPanel from "../components/settingsPanel";
import pageTransition from "../components/pageTransition";
import StartSettings from "../components/startSettings";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useMatomo } from "@datapunt/matomo-tracker-react";
import MetaHelmet from "../components/metaHelmet";
import Cookies from "js-cookie";



const More: React.FC = () => {
    // Load settings
    const [settingsSet] = useState<boolean>(() => !!localStorage.getItem('settings-set'));
    const { t } = useTranslation();

    const location = useLocation();
    const { trackPageView } = useMatomo();

    const navigate = useNavigate();

    const [lastUpdate, setLastUpdate] = useState("");

    const parseDate = (timestamp: string) => {
        const year = parseInt(timestamp.substring(0, 4));
        const month = parseInt(timestamp.substring(4, 6));
        const day = parseInt(timestamp.substring(6, 8));
      
        return (day + '.' + month + '.' + year);
    }

    const clearData = () => {
        localStorage.clear();
        Object.keys(Cookies.get()).forEach(cookie => Cookies.remove(cookie));
        window.location.reload();
    };
  
    useEffect(() => {
        let lastUpdate = localStorage.getItem('last-update');
        if(lastUpdate) {
            setLastUpdate(lastUpdate);
        }

      trackPageView({
        href: window.location, // URL der aktuellen Seite
      });
    }, [location]);
    
    return (
        !settingsSet ? (
            <ion-page class="sg-body">
                <StartSettings />
            </ion-page>
        ) : (
        <ion-page class="sg-body">
            <div className="page-container">
            <MetaHelmet 
                title={t('settings')}
            />
            <ion-header mode="ios">
                        <div className="header-container venue ion-padding">
                            <button className="arrow-back"
                                style={{ backgroundImage: `url("/icons/back_arrow_white.svg")` }} onClick={() => navigate(-1)}></button>
                            <h1 className="start-title left">{t('morePage')}</h1>
                        </div>
            </ion-header>
            <div className="links-page">
                <div className="links-page__links">
                    <Link state={{ fromInternal: true }} className="links-page__links-line" to="/funktionen">{t('our-functions')}
                        <button className="arrow-forward"
                            style={{ backgroundImage: `url("/icons/back-white.svg")` }} onClick={() => navigate(-1)}>
                        </button>
                    </Link>
                    <Link state={{ fromInternal: true }} className="links-page__links-line" to="/partner">{t('become-partner')}
                        <button className="arrow-forward"
                            style={{ backgroundImage: `url("/icons/back-white.svg")` }} onClick={() => navigate(-1)}>
                        </button>
                    </Link>
                    <Link state={{ fromInternal: true }} className="links-page__links-line" to="/about-us">{t('about-us')}
                        <button className="arrow-forward"
                            style={{ backgroundImage: `url("/icons/back-white.svg")` }} onClick={() => navigate(-1)}>
                        </button>
                    </Link>
                    <Link state={{ fromInternal: true }} className="links-page__links-line" to="/agb">{t('AGB')}
                        <button className="arrow-forward"
                            style={{ backgroundImage: `url("/icons/back-white.svg")` }} onClick={() => navigate(-1)}>
                        </button>
                    </Link>
                    <Link state={{ fromInternal: true }} className="links-page__links-line" to="/datenschutz">{t('data-privacy')}
                        <button className="arrow-forward"
                            style={{ backgroundImage: `url("/icons/back-white.svg")` }} onClick={() => navigate(-1)}>
                        </button>
                    </Link>
                    <Link state={{ fromInternal: true }} className="links-page__links-line" to="/impressum">Impressum
                        <button className="arrow-forward"
                            style={{ backgroundImage: `url("/icons/back-white.svg")` }} onClick={() => navigate(-1)}>
                        </button>
                    </Link>
                    <SettingsPanel />
                </div>
                <div className="social-media-links">
                <a href="https://www.facebook.com/smartGastroAT/" target="_blank" className="contact-link social-media-links__item"
                style={{ backgroundImage: `url("/icons/facebook-blue.svg")` }}></a>
                <a href="https://www.instagram.com/smartgastroat/" target="_blank" className="contact-link social-media-links__item"
                style={{ backgroundImage: `url("/icons/instagram_gradient.png")` }}></a>
                <a href="https://www.tiktok.com/@smartgastroat" target="_blank" className="contact-link social-media-links__item"
                style={{ backgroundImage: `url("/icons/TikTok_Icon_Black_Circle.png")` }}></a>
                </div>
                <div className="settings-software-information">
                    <button className="sg-button" onClick={clearData}>
                            {t('clearData')}
                    </button>
                    <div className="settings-software-information__info">
                        Web-App Version: 2.2.1<br></br>
                        {lastUpdate && (
                            <span>
                                {t('lastApiUpdate')} 
                                {parseDate(lastUpdate)}
                            </span>
                        )}
                    </div>
                </div>
            </div>
            </div>
        </ion-page>
        )
    );
}

export default pageTransition(More);

